/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileGz = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586V10h-2V9h-5V4H6v16h12v-1h2v3H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="M16 11.887c.211 0 .421.019.628.055.212.037.41.092.594.165v.912a4.22 4.22 0 0 0-.628-.152 3.195 3.195 0 0 0-.552-.049c-.529 0-.936.14-1.222.421-.28.276-.42.675-.42 1.195 0 .579.122 1.014.366 1.303.248.285.625.428 1.13.428.194 0 .383-.011.567-.034.023-.003.045-.008.068-.01v-.973l-.848-.28v-.58h1.856v2.464a4.032 4.032 0 0 1-.518.192 3.7 3.7 0 0 1-.558.112 4.197 4.197 0 0 1-.594.04c-.846 0-1.488-.225-1.925-.676-.432-.45-.648-1.113-.648-1.986 0-.539.106-.996.317-1.374.217-.381.524-.672.924-.87.405-.202.893-.303 1.463-.303zm5.886.842-2.374 3.36h2.464V17h-3.823v-.766l2.36-3.34h-2.277v-.91h3.65z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileGz as FileGz };
